import axiosConfig from './config';

export const getExternalHomepageContentUrl = async () => await axiosConfig.get('external-page/homepage-content-url');
